var SessionTimerModalCms = /** @class */ (function () {
    function SessionTimerModalCms() {
        this.cancelButtonText = 'Continue Shopping';
        this.continueButtonText = 'Continue';
        this.expiredHeadingText = 'Your session has expired';
        this.expiredModalContent = 'Too much time has passed since there\'s been any activity. We expired your browser session to protect your personal info.';
        this.headingText = 'Are you still there?';
        this.modalContent = 'As a security measure, your browser session will expire in <strong>5</strong> minutes.<br /><br />Select Continue to extend your session.';
    }
    return SessionTimerModalCms;
}());
export { SessionTimerModalCms };
//# sourceMappingURL=SessionTimerModal.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/SessionTimerModal/SessionTimerModal.cms.js
// module id = 1732
// module chunks = 8